/**
 * Converts an event type from SNAKE_CASE to a human-readable Title Case format
 */
export const getPrettyEventName = (eventType: string): string => {
  // Convert from SNAKE_CASE to Title Case with spaces
  const withSpaces = eventType.replace(/_/g, " ").toLowerCase();
  return withSpaces
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
